import styled from "styled-components";

export const BasicButton= styled.button`
    height: 50px;  
    border-radius: 100px;
    font-weight: bold;
    line-height: 18px;
    margin: 20px;
    text-align: center;
    border: 2px solid ${(props) => props.theme.brandColor1};
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    padding-right: 40px;
    padding-left: 40px;
    cursor: pointer;
    @media screen and (max-width: 470px) {
        margin: 20px 0;
    }
`

export const PrimaryButton = styled(BasicButton)`
    background: ${(props) => props.theme.brandColor1};
    color: #FFFFFF;
    &:disabled {
        opacity:50%
    }
`

export const SecondaryButton = styled(BasicButton)`
    color: ${(props) => props.theme.brandColor1};
    background: white;
`

export const BasicInput = styled.input`
    height: 50px;
    border: 2px solid #E1E1E1;
    border-radius: 100px;
    padding-left: 15px;
    padding-right: 15px;
    box-sizing: border-box;
`